<app-forgot-password-form
  [senderEmail]="senderEmail"
  (submit)="onSubmit($event)"
></app-forgot-password-form>

<dx-load-panel
  shadingColor="rgba(0,0,0,0.4)"
  [(visible)]="loadingVisible"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  [hideOnOutsideClick]="false"
>
</dx-load-panel>
